import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoStockService } from 'src/app/services/movimiento-stock.service';
import { PrecioReferenciaService } from 'src/app/services/precio-referencia.service';
import { ProductoService } from 'src/app/services/producto.service';
import { RubroService } from 'src/app/services/rubro.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: "app-exist-stock-valorizado",
  templateUrl: "./exist-stock-valorizado.component.html",
  styleUrls: ["./exist-stock-valorizado.component.scss"],
  providers: [SecurityService],
})
export class ReporteInventarioExistStockValorizadoComponent implements OnInit {

  // Form
  formHeader: FormGroup

  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = "_RB_TIPO_VISTA_RESUMEN_"
  readonly RB_TIPO_VISTA_DETALLE: String = "_RB_TIPO_VISTA_DETALLE_"

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  optionsRubro: Array<any> = [];
  optionsBodega: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsPrecioRef: Array<any> = [];
  optionsEstado: Array<any> = [];

  private resumen_currentPayload: any = null
  resumen_loading: boolean = false
  resumen_listaMovimientos: Array<any> = null
  resumen_listaMovimientosAll: Array<any> = null
  resumen_paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null

  private detalle_currentPayload: any = null
  detalle_loading: boolean = false
  detalle_listaMovimientos: Array<any> = null
  detalle_listaMovimientosAll: Array<any> = null
  detalle_paginationContext: PaginationContext = new PaginationContext()
  detalle_totales: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private bodegaService: BodegaService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private productoService: ProductoService,
    private movimientoStockService: MovimientoStockService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private precioReferenciaService: PrecioReferenciaService,
    private datesService: DatesService,
    private utilsService: UtilsService
  ) {
    this.log = this.clog.log('MOVIMIENTO STOCK')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.resumen_paginationContext.RecordsByPage = 10
    this.detalle_paginationContext.RecordsByPage = 10

    this.createForm()
    this.formChangesSubscriptions()
    this.loadBodegas()
    this.loadRubros()
    this.loadPreciosReferencia()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN],
      fecha: [this.datesService.CurrentDateToShortTimeString(), [Validators.required]],
      bodega: [[]],
      rubro: [[]],
      familia: [[]],
      estado: [true],
      precioRef: [null],
      mayor: [true],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("rubro").valueChanges.subscribe((rubro: string) => {
      this.onRubroSelect(rubro)
    })
  }
  loadPreciosReferencia() {
    this.optionsPrecioRef = this.precioReferenciaService.GetPreciosReferencia();
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('precioRef'), this.optionsPrecioRef)
  }

  private loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
    })
  }

  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map(p => ({ value: p.codigo, label: p.descripcion }))
    })
  }

  onRubroSelect(ev) {
    const listaRubros = this.formHeader.get('rubro').value
    this.optionsFamilia = []
    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i])
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubro(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })
  }

  buscar(pageNumber: number) {
    // Evita mostrar "Total General" con total de **resumen** (agrupado por SKU) mientras llega el detalle;
    // el Excel exporta **detalle** (SKU × bodega) y esos totales no coinciden.
    this.resumen_totales = null;
    this.detalle_totales = null;
    this.resumenBuscar(pageNumber);
    this.detalleBuscar(pageNumber);
  }

  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.resumen_paginationContext.CurrentPage = pageNumber

    //** DECLARACION VARIABLE **/
    this.resumen_listaMovimientos = null;
    this.resumen_listaMovimientosAll = null;

    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_movimiento: this.formHeader.get('fecha').value,
        producto_activo: this.formHeader.get('estado').value,
        listaBodega: this.formHeader.get('bodega').value,
        listaRubro: this.formHeader.get('rubro').value,
        listaFamilia: this.formHeader.get('familia').value,
        precio_compra: this.formHeader.get('precioRef').value,
        mayorCero: this.formHeader.get('mayor').value,
      },
      paginaActual: 1, //this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }

    this.resumen_currentPayload = _.cloneDeep(inputParams)

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true
    this.movimientoStockService.obtenerStockValorizadoResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.resumen_loading = false
        return
      }

      const { registros } = respuesta
      this.resumen_listaMovimientosAll = registros

      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage) //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1
      
      this.showPageResumen(this.resumen_paginationContext.CurrentPage)
      this.calculateTotalesResumen();
      this.resumen_loading = false
    })
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage)
  }

  onPageChangeResumen(context: PaginationContext) {
    this.showPageResumen(context.RequestedPage)
  }

  calculateTotalesResumen() {
    this.resumen_totales = {
      total: Math.round(this.calcularTotalTotal(this.resumen_listaMovimientosAll)),//_.sumBy(this.listaMovimientosAll, 'costo_total'),
      total_caja: this.calcularSaldoTotal(this.resumen_listaMovimientosAll),//_.sumBy(this.listaMovimientosAll, 'costo_total'),
      total_fraccion: this.calcularSaldoTotalUnidad(this.resumen_listaMovimientosAll),//_.sumBy(this.listaMovimientosAll, 'costo_total'),
    }
  }

  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.detalle_paginationContext.CurrentPage = pageNumber

    //** DECLARACION VARIABLE PARA DETALLE */
    this.detalle_listaMovimientos = null;
    this.detalle_listaMovimientosAll = null;

    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_movimiento: this.formHeader.get('fecha').value,
        producto_activo: this.formHeader.get('estado').value,
        listaBodega: this.formHeader.get('bodega').value,
        listaRubro: this.formHeader.get('rubro').value,
        listaFamilia: this.formHeader.get('familia').value,
        precio_compra: this.formHeader.get('precioRef').value,
        mayorCero: this.formHeader.get('mayor').value,
      },
      paginaActual: 1, //this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.paginationContext.RecordsByPage
    }

    this.detalle_currentPayload = _.cloneDeep(inputParams)

    this.log('inputParams', JSON.stringify(inputParams))

    this.detalle_loading = true
    this.movimientoStockService.obtenerStockValorizadoDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.detalle_totales = null
        this.detalle_loading = false
        return
      }

      const { registros } = respuesta
      this.detalle_listaMovimientosAll = registros
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage) //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage)
      this.calculateTotalesDetalle();
      this.detalle_loading = false
    })
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage)
  }

  onPageChangeDetalle(context: PaginationContext) {
    this.showPageDetalle(context.RequestedPage)
  }
  calculateTotalesDetalle() {
    this.detalle_totales = {
      total_detalle: Math.round(this.calcularTotalTotalXBodega(this.detalle_listaMovimientosAll)),//_.sumBy(this.listaMovimientosAll, 'costo_total'),
      total_caja_detalle: this.calcularSaldoTotalBodega(this.detalle_listaMovimientosAll),//_.sumBy(this.listaMovimientosAll, 'costo_total'),
      // En Stock Valorizado Detalle no siempre viene `formato_codigo`, por lo que
      // `calcularSaldoTotalXBodegaUnidad` puede devolver 0 aunque la columna Fracción muestre valores (ej: 4).
      // Para que el total cuadre con la tabla, sumamos el mismo cálculo que se renderiza en la columna.
      total_fraccion_detalle: _.sumBy(this.detalle_listaMovimientosAll || [], (x: any) => {
        const listado = x && x.listaStockxUnidadesxBodega ? x.listaStockxUnidadesxBodega : [];
        // Caso UNID-only: debe ir a Fracción (unidad), no a Caja.
        const saldo = x && x.saldo != null ? Number(x.saldo) : 0;
        return Number(this.calcularStockFormatoSecundarioConSaldo(listado, saldo) || 0);
      }),
    }
  }
  exportarExcel() {
    const inputParams = _.cloneDeep(this.detalle_currentPayload)
    inputParams.entidad.retornaExcel = true
    delete inputParams.paginaActual
    delete inputParams.cantidadRegistrosPorPagina

    this.log('XLS', JSON.stringify(inputParams))

    this.movimientoStockService.obtenerStockValorizadoDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  obtenerFormatoPrincipal(listado: any) {
    return this.utilsService.obtenerFormatoPrincipal(listado);
  }

  calcularStockFormatoPrincipal(listado: any) {
    return this.utilsService.calcularStockFormatoPrincipal(listado);
  }
  calcularStockFormatoSecundario(listado: any) {
    return this.utilsService.calcularStockFormatoSecundario(listado);
  }

  // Versiones que consideran el saldo (y tratan correctamente el caso UNID-only)
  calcularStockFormatoPrincipalConSaldo(listado: any, saldo: number) {
    return this.utilsService.calcularStockFormatoPrincipalConSaldo(listado, saldo);
  }

  calcularStockFormatoSecundarioConSaldo(listado: any, saldo: number) {
    return this.utilsService.calcularStockFormatoSecundarioConSaldo(listado, saldo);
  }
  calcularSaldoTotal(registros: any) {
    return this.utilsService.calcularSaldoTotal(registros);
  };

  calcularSaldoTotalUnidad(registros: any) {
    return this.utilsService.calcularSaldoTotalUnidad(registros);
  };

  calcularSaldoTotalBodega(registros: any) {
    return this.utilsService.calcularSaldoTotalBodega(registros);
  };

  calcularSaldoTotalUnidadBodega(registros: any) {
    return this.utilsService.calcularSaldoTotalXBodegaUnidad(registros);
  };

  calcularTotalTotalXBodega(registros: any) {
    return this.utilsService.calcularTotalTotalPrecioRefXBodega(registros);
  };

  calcularTotalTotal(registros: any) {
    return this.utilsService.calcularTotalTotalPrecioRef(registros);
  };

  calcularPrecioRefTodosLosFormatos(listado: any, precio_ref_formato_principal: number) {
    return this.utilsService.calcularPrecioRefTodosLosFormatos(listado, precio_ref_formato_principal);
  }

  /** Detalle por bodega: mismo criterio que columna `costo_total` del Excel (Util.CalculosUnidadesFormatos). */
  calcularPrecioRefTodosLosFormatosBodega(
    listado: any,
    precio_ref_formato_principal: number,
    costo_formato_principal?: number | null
  ) {
    return this.utilsService.calcularPrecioRefTodosLosFormatosBodega(
      listado,
      precio_ref_formato_principal,
      costo_formato_principal
    );
  }

}
